import { AuthPartner } from "@happy-legal/graphql-types";
import { createContext, ReactNode } from "react";
import {
  authPartnerReducer,
  TAuthParterState,
  TAuthPartnerAction,
} from "../reducer";
import { createProvider, IObjectContextType } from "./ProviderFactory";

export const AuthPartnerContext = createContext<
  IObjectContextType<TAuthParterState, TAuthPartnerAction>
>(undefined!);
// TODO: https://www.rivoltafilippo.com/typing-react-context-to-avoid-an-undefined-default-value

AuthPartnerContext.displayName = "Auth Partner Context";

export const authPartnerInitState: TAuthParterState = {
  authPartner: {} as AuthPartner,
  allAuthPartners: {
    items: [],
    total: 0,
  },
};

const AuthPartnerProvider = ({ children }: { children: ReactNode }) =>
  createProvider(
    AuthPartnerContext,
    authPartnerReducer,
    authPartnerInitState,
    children
  );

export default AuthPartnerProvider;
